import { useQueryGetProjectChildProjects } from '../core/queries/projects.queries';

export function useHasChildProjects(projectID: string) {
  const childProjects = useQueryGetProjectChildProjects(projectID);

  // The useQueryGetProjectChildProjects result includes the project with the ID being passed in
  // so we expect there to always be 1 result. If there are more than 1, then the project has children.
  return (childProjects.data && childProjects.data.length > 1) || false;
}
